import React, { useState, useEffect } from "react";
import { telegramService } from "../../services/api";

const AdminTelegram: React.FC = () => {
    const [token, setToken] = useState("");
    const [chatId, setChatId] = useState("");
    const [credentials, setCredentials] = useState<{ token: string; chat_id: string }[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        loadCredentials();
    }, []);

    const loadCredentials = async () => {
        try {
            setIsLoading(true);
            const data = await telegramService.getAll();
            setCredentials(data);
        } catch {
            setError("Erreur lors du chargement des credentials");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");
        setIsSubmitting(true);
        try {
            await telegramService.add(token, chatId);
            setSuccess("Credential Telegram ajouté avec succès");
            setToken("");
            setChatId("");
            loadCredentials();
            setTimeout(() => setSuccess(""), 4000);
        } catch {
            setError("Erreur lors de l'ajout du credential");
        } finally {
            setIsSubmitting(false);
        }
    };

    const maskToken = (t: string) =>
        t.length > 10 ? t.slice(0, 6) + "••••••" + t.slice(-4) : "••••••";

    return (
        <div className="min-h-screen py-8 px-4">
            <div className="max-w-2xl mx-auto">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-white mb-1">Telegram</h1>
                    <p className="text-gray-400 text-sm">Configurer les notifications Telegram</p>
                </div>

                {success && (
                    <div className="mb-6 p-4 bg-green-500/20 border border-green-500/50 rounded-xl text-green-400 text-sm">
                        {success}
                    </div>
                )}
                {error && (
                    <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl text-red-400 text-sm">
                        {error}
                    </div>
                )}

                {/* Formulaire */}
                <div className="bg-primary-light/30 border border-white/10 rounded-2xl p-6 mb-8">
                    <h2 className="text-lg font-semibold text-white mb-5 flex items-center space-x-2">
                        <svg className="w-5 h-5 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                        </svg>
                        <span>Ajouter un bot</span>
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Token du bot
                            </label>
                            <input
                                type="text"
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                                className="input-field"
                                placeholder="ex: 8755384415:AAGX5ccW..."
                                required
                            />
                            <p className="text-gray-500 text-xs mt-1">Obtenu via @BotFather sur Telegram</p>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">
                                Chat ID
                            </label>
                            <input
                                type="text"
                                value={chatId}
                                onChange={(e) => setChatId(e.target.value)}
                                className="input-field"
                                placeholder="ex: 7950889398"
                                required
                            />
                            <p className="text-gray-500 text-xs mt-1">ID du canal ou groupe qui reçoit les notifications</p>
                        </div>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="w-full py-3 rounded-xl bg-accent hover:bg-accent-light text-white font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isSubmitting ? "Enregistrement..." : "Enregistrer"}
                        </button>
                    </form>
                </div>

                {/* Liste des credentials */}
                <div className="bg-primary-light/30 border border-white/10 rounded-2xl p-6">
                    <h2 className="text-lg font-semibold text-white mb-4">Bots configurés</h2>

                    {isLoading ? (
                        <p className="text-gray-400 text-sm">Chargement...</p>
                    ) : credentials.length === 0 ? (
                        <p className="text-gray-500 text-sm">Aucun bot configuré</p>
                    ) : (
                        <div className="space-y-3">
                            {credentials.map((cred, i) => (
                                <div key={i} className="flex items-center justify-between bg-primary-dark/50 rounded-xl px-4 py-3 border border-white/5">
                                    <div>
                                        <p className="text-white text-sm font-medium font-mono">
                                            {maskToken(cred.token)}
                                        </p>
                                        <p className="text-gray-400 text-xs mt-0.5">Chat ID : {cred.chat_id}</p>
                                    </div>
                                    <div className="w-2 h-2 rounded-full bg-green-400" title="Actif" />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminTelegram;
